import {
  Document,
  Page,
  PDFViewer,
  StyleSheet,
  Text,
  View,
} from "@react-pdf/renderer";

const fontStyles = StyleSheet.create({
  TextCenter: {
    textAlign: "center",
  },
  boldText: {
    fontWeight: "bold",
  },
  fontXL: {
    fontSize: 12,
  },
  fontLg: {
    fontSize: 10,
  },
  fontMd: {
    fontSize: 8.4,
  },
  fontSm: { fontSize: 7.4 },
});

export const styles = StyleSheet.create({
  ...fontStyles,
  page: {
    paddingHorizontal: 30,
    paddingVertical: 15,
    fontFamily: "HostGrotesk",
    backgroundColor: "white",
    ...fontStyles.fontMd,
  },
  header: {
    marginTop: 5,
    marginBottom: 10,
    ...fontStyles.fontXL,
  },
  table: {
    borderLeft: 1,
    width: "100%",
  },
  tableRow: {
    width: "100%",
    flexDirection: "row",
    borderBottom: 1,
  },
  tableCell: {
    paddingVertical: 1,
    paddingHorizontal: 3,
    borderRight: 1,
  },
  tableCell1: {
    width: "40%",
    paddingVertical: 1,
    paddingHorizontal: 3,
    borderRight: 1,
  },
  tableCell2: {
    width: "60%",
    paddingVertical: 1,
    paddingHorizontal: 3,
    borderRight: 1,
  },
  flex: { flexDirection: "row" },
});

const FumigationCertificateInvoice = () => {
  return (
    <PDFViewer width="100%" height="800">
      <Document>
        <Page style={styles.page} size="A4">
          {/* Header */}
          <View style={[styles.TextCenter, styles.boldText, styles.header]}>
            <View style={{ minHeight: 60 }}></View>
            <Text>FUMIGATION CERTIFICATE</Text>
          </View>

          <View style={[styles.table, { borderTop: 1 }]}>
            <View style={[styles.tableRow]}>
              <View style={[styles.tableCell1, { width: "40%" }]}>
                <Text style={[styles.boldText]}>Dte. Of PPQS Regd .No.:</Text>
                <Text>590 / MB</Text>
              </View>
              <View style={[styles.tableCell2]}>
                <Text style={[styles.boldText]}>
                  Treatment Certificate Number:
                </Text>
                <Text>FPM/GDM/MAR/MB/054/24-25</Text>
              </View>
            </View>

            <View style={[styles.tableRow]}>
              <View style={[styles.tableCell1, styles.flex, { padding: 0 }]}>
                <Text style={[styles.tableCell, styles.boldText]}>Date</Text>
                <Text
                  style={[styles.tableCell, { flexGrow: 1, borderRight: 0 }]}
                >
                  27.06.2017
                </Text>
              </View>
              <View style={[styles.tableCell2, styles.flex, { padding: 0 }]}>
                <Text style={[styles.tableCell, styles.boldText]}>
                  Date of Issue
                </Text>
                <Text
                  style={[styles.tableCell, { flexGrow: 1, borderRight: 0 }]}
                >
                  06.03.2025
                </Text>
              </View>
            </View>

            <Text style={[styles.tableRow, styles.tableCell]}>
              This is to certify that the goods described below were treated in
              accordance with the fumigation treatment requirements of importing
              country (INDONESIA) and declared that the consignment has been
              verified free of impervious surfaces/layers such as plastic
              wrapping or laminated plastic films, lacquered or painted
              surfaces, aluminium foil,tarred or waxed paper etc. that may
              adversely affect the penetration of the fumigant, prior to
              fumigation.
            </Text>
          </View>

          {/* Details of Treatment */}
          <View style={[styles.table]}>
            {/*  HEADER */}
            <View style={[styles.tableRow, styles.tableCell]}>
              <Text style={[styles.boldText, styles.fontLg]}>
                Details of Treatment
              </Text>
            </View>
            <View style={[styles.tableRow]}>
              <Text style={[styles.tableCell1]}>Name of Fumigant</Text>
              <Text style={[styles.tableCell2]}>METHYL BROMIDE</Text>
            </View>
            <View style={[styles.tableRow]}>
              <Text style={[styles.tableCell1]}>Date of Fumigation</Text>
              <Text style={[styles.tableCell2, styles.boldText]}>
                05.03.2025
              </Text>
            </View>
            <View style={[styles.tableRow]}>
              <Text style={[styles.tableCell1]}>Place of Fumigation</Text>
              <Text style={[styles.tableCell2, styles.boldText]}>
                MUNDRA,GUJARAT,INDIA
              </Text>
            </View>
            <View style={[styles.tableRow]}>
              <Text style={[styles.tableCell1]}>
                Dosage of Fumigant (Gm/m³)
              </Text>
              <Text style={[styles.tableCell2, styles.boldText]}>32 Gm/m³</Text>
            </View>
            <View style={[styles.tableRow]}>
              <Text style={[styles.tableCell1]}>
                Duration of Fumigation (hours)
              </Text>
              <Text style={[styles.tableCell2, styles.boldText]}>24 HOURS</Text>
            </View>
            <View style={[styles.tableRow]}>
              <Text style={[styles.tableCell1]}>
                Average Ambient Temperature During Fumigation (°C)
              </Text>
              <Text style={[styles.tableCell2, styles.boldText]}>22.0°C</Text>
            </View>
            <View style={[styles.tableRow]}>
              <Text style={[styles.tableCell1]}>
                Fumigation performed under gastight sheets
              </Text>
              <Text style={[styles.tableCell2, styles.boldText]}>
                YES/
                <Text style={{ textDecoration: "line-through" }}>NO</Text>
              </Text>
            </View>
            <View style={[styles.tableRow]}>
              <View style={[styles.tableCell1]}>
                <Text>
                  If containers are not fumigated under gas-tight
                  sheets,pressure decay value (from 200-100 Pascal's) in
                  seconds.
                </Text>
              </View>
              <View style={[styles.tableCell2, styles.boldText]}>
                <Text>N.A</Text>
              </View>
            </View>
          </View>

          {/* Description of Goods */}
          <View style={[styles.table]}>
            {/*  HEADER */}
            <View style={[styles.tableRow, styles.tableCell]}>
              <Text style={[styles.boldText, styles.fontLg]}>
                Description of Goods
              </Text>
            </View>
            <View style={[styles.tableRow]}>
              <Text style={[styles.tableCell1]}>
                Container Number (or numerical link)/ Seal Number Seal Number
              </Text>
              <Text style={[styles.tableCell2]}>
                <Text style={[styles.boldText]}>
                  SAID TO HAVE BEEN LOADED IN [04 X 20']
                </Text>
                894731, 560284, 173905, 742619
              </Text>
            </View>

            <View style={[styles.tableRow]}>
              <Text style={[styles.tableCell1]}>
                Name & Address of Exporter
              </Text>
              <View style={[styles.tableCell2]}>
                <Text>MS. LAXMI ENTERPRISE</Text>
                <Text>
                  PLOT NO-36, GROUND FLOOR, SHUBHAM INDUSTRY-2, SANIYA HEMED,
                </Text>
                <Text>SURAT, GUJARAT, 395006 (INDIA)</Text>
              </View>
            </View>

            <View style={[styles.tableRow]}>
              <Text style={[styles.tableCell1]}>
                Name & Address of Importer
              </Text>
              <View style={[styles.tableCell2]}>
                <Text>PT BERKAT JAYA ONGGUL</Text>
                <Text>
                  JALAN ROMOKALISARI 82B, BENOWO, SURABAYA, 60192,INDONESIA
                </Text>
                <Text>NPWP: 0759 2123 1960 4000</Text>
              </View>
            </View>

            <View style={[styles.tableRow]}>
              <Text style={[styles.tableCell1]}>Notify Party</Text>
              <Text style={[styles.tableCell2]}>SAME AS IMPORTER</Text>
            </View>

            <View style={[styles.tableRow]}>
              <Text style={[styles.tableCell1]}>
                Type and description of cargo
              </Text>
              <Text style={[styles.tableCell2]}>INDIA GROUNDNUT KERNELS</Text>
            </View>

            <View style={[styles.tableRow]}>
              <View style={[styles.tableCell1]}>
                <Text>Quantity (MTs)/No. of packages/No.</Text>
                <Text>pieces</Text>
              </View>
              <View style={[styles.tableCell2]}>
                <Text>GROSS. WT.: 78.156 MTS, NET. WT.:78.000 MTS</Text>
                <Text>(TOTAL 1560 BAGS)</Text>
              </View>
            </View>

            <View style={[styles.tableRow]}>
              <Text style={[styles.tableCell1]}>
                Description of packaging material
              </Text>
              <Text style={[styles.tableCell2]}>
                (PACKED IN NEW PP BAGS) NET 50 KGS & GROSS 50.1 KGS EACH BAG.
              </Text>
            </View>

            <View style={[styles.tableRow]}>
              <Text style={[styles.tableCell1]}>Shipping mark or brand</Text>
              <Text style={[styles.tableCell2]}>NO MARKS</Text>
            </View>

            <View style={[styles.tableRow]}>
              <Text style={[styles.tableCell1]}>Name of the Vessel / Ship</Text>
              <Text style={[styles.tableCell2]}>BY SEA</Text>
            </View>

            <View style={[styles.tableRow]}>
              <Text style={[styles.tableCell1]}>Port & Country of Loading</Text>
              <Text style={[styles.tableCell2]}>MUNDRA, INDIA</Text>
            </View>

            <View style={[styles.tableRow]}>
              <Text style={[styles.tableCell1]}>Decleared Port of Entry</Text>
              <Text style={[styles.tableCell2]}>SURABAYA, INDONESIA</Text>
            </View>

            <View style={[styles.tableRow]}>
              <Text style={[styles.tableCell1]}>Additional Declaration</Text>
              <Text style={[styles.tableCell2]}>
                INVOICE NO. EXP/24-25/014 DATE: 04/03/2025
              </Text>
            </View>
            <View style={[styles.tableRow]}>
              <Text style={[styles.tableCell1]}>
                Name & Signature of accredited Fumigation Operator with seal &
                date/Accreditation Number
              </Text>
              <View style={[styles.tableCell2, { minHeight: 130 }]}>
                <Text></Text>
              </View>
            </View>

            <View style={[styles.tableRow]}>
              <Text style={[styles.tableCell1]}>Date&Place</Text>
              <View style={[styles.tableCell]}>
                <Text>06.03.2025</Text>
              </View>
              <View style={[styles.tableCell, { flexGrow: 1 }]}>
                <Text> Gandhidham</Text>
              </View>
            </View>
          </View>

          {/* Footer */}
          <Text style={[styles.fontSm]}>
            *No financial liability attaches to or is assumed by the certifying
            company, its partners, directors of representatices in respect to
            this certificate.
          </Text>
        </Page>
      </Document>
    </PDFViewer>
  );
};

export default FumigationCertificateInvoice;
